import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { PurchaseTypeRuleService } from 'pages/quote-setup/purchase-type-rules/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(PurchaseTypeRuleService, DialogService, EventAggregator)
export class PurchaseTypeRules {
    constructor(purchaseTypeRuleService, dialogService, ea) {
        this.ea = ea;
        this.purchaseTypeRuleService = purchaseTypeRuleService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'purchasePartTypeName', sortOrder: 'asc', caption: 'Purchase Part Type', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'projectNumber', caption: 'Project' },
            { dataField: 'customerName', caption: 'Customer' },
            { dataField: 'plantName', caption: 'Plant' },
            { dataField: 'chargeSGA' },
            { dataField: 'chargeProfit' },
            { dataField: 'markupFactor' },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('purchase-type-rules:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (purchaseTypeRule) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.purchaseTypeRuleService.delete(purchaseTypeRule.id);
                this.grid.refresh();
                toastr.success('Purchase type rule was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.purchaseTypeRuleService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.purchaseTypeRuleService.editor, model: { id: data.id } });
    };
}

